const About = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-6">About MAAP</h1>
      <p className="text-lg mb-6">
        The Medical Association of Andhra Pradesh (MAAP) is the premier professional organization representing medical professionals and healthcare institutions across Andhra Pradesh. Founded with a vision to unite healthcare providers and improve medical standards, MAAP has been at the forefront of healthcare advocacy since its inception.
      </p>
      
      <div className="grid md:grid-cols-2 gap-8 mt-8">
        <div>
          <h2 className="text-2xl font-semibold mb-4">Our Mission</h2>
          <p className="mb-4">
            To foster excellence in healthcare delivery by supporting medical professionals, promoting ethical practices, and facilitating continuous medical education in Andhra Pradesh.
          </p>
        </div>
        
        <div>
          <h2 className="text-2xl font-semibold mb-4">Our Vision</h2>
          <p className="mb-4">
            To be the leading voice in healthcare policy and practice in Andhra Pradesh, ensuring quality healthcare access for all citizens.
          </p>
        </div>
      </div>

      <div className="mt-8">
        <h2 className="text-2xl font-semibold mb-4">Key Objectives</h2>
        <ul className="list-disc pl-6 space-y-3">
          <li>Represent and advocate for medical professionals across all specialties</li>
          <li>Organize continuing medical education programs and workshops</li>
          <li>Collaborate with government bodies on healthcare policy development</li>
          <li>Promote ethical medical practices and professional standards</li>
          <li>Facilitate networking and knowledge sharing among healthcare providers</li>
          <li>Support research and innovation in medical practice</li>
        </ul>
      </div>
    </div>
  );
};

export default About; 